<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <div class="col-lg-12 margin-bottom-10 hidden-lg hidden-md hidden-sm hidden-xl">
                            <router-link :to="{'name': 'AlterarSenha'}" class="button gray small block-mobile">
                                <i class="material-icons">lock</i>
                                Alterar senha
                            </router-link>
                        </div>
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">account_circle</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">
                                        <div class="row">

                                            <div class="col-xl-3 col-lg-3 col-md-3 col-xs-12 overflow-hidden">
                                                <center>
                                                    <div class="avatar-wrapper">
                                                        <div class="img" :style="{'background-image': 'url(' + form.imagem + ')'}"></div>
                                                        <div class="upload-button"></div>
                                                        <input class="file-upload" type="file" name="imagem" @change="getBase64Imagem" accept="image/*"/>
                                                    </div>
                                                </center>
                                            </div>
                                            <div class="col-xl-9 col-lg-7">
                                                <div class="row">

                                                    <div class="col-xl-6 col-md-6 col-lg-10">
                                                        <div class="submit-field">
                                                            <h5>Nome completo</h5>
                                                            <input type="text" class="with-border" placeholder="Informe seu nome completo..." v-model="form.nome">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-6 col-md-6 col-lg-10">
                                                        <div class="submit-field">
                                                            <h5>E-mail</h5>
                                                            <input type="email" class="with-border" placeholder="Informe seu e-mail aqui" v-model="form.email">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-4 col-xs-8 col-md-5 col-lg-7">
                                                        <div class="submit-field">
                                                            <h5>Telefone</h5>
                                                            <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-4 col-xs-10 col-md-4" v-if="$root.user.tipo == 'contratante'">
                                                        <div class="submit-field">
                                                            <h5 v-show="$root.user.tipo == 'contratante'">CPF:</h5>
                                                            <!-- <h5 v-show="$root.user.tipo != 'contratante'">CNPJ:</h5> -->
                                                            <the-mask :mask="['###.###.###-##', '##.###.###/####-##']" class="with-border" v-model="form.doc" :placeholder="$root.user.tipo == 'contratante' ? '000.000.000-00' : '00.000.000/0000-00'"/>
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-4 col-xs-10 col-md-4" v-if="$root.user.tipo == 'contratante'">
                                                        <div class="submit-field">
                                                            <h5>Data de nascimento:</h5>
                                                            <the-mask :mask="['##/##/####']" :masked="true" type="tel" class="with-border" autocomplete="new-password" v-model="form.dataNascimento" placeholder="___ /____ /_____" required />
                                                        </div>
                                                    </div>


                                                    <!-- Button -->
                                                    <div class="col-xl-12 margin-bottom-10">
                                                        <button type="submit" class="button big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                            <i class="material-icons">save</i>
                                                            Salvar alterações
                                                        </button>
                                                    </div>
                                                    <div class="col-xl-12 margin-bottom-10">
                                                        <button v-on:click="apagarConta()" type="button" class="button color-red block-mobile big">
                                                            <i class="material-icons">block</i>
                                                            Apagar minha conta
                                                        </button>
                                                    </div>                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>
    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name: 'Conta',
    components: {
        'Top': Top,
        'Sidebar': Sidebar,
        'Toolbar': Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "nome":             self.$root.user.nome,
                "email":            self.$root.user.email,
                "doc":              self.$root.user.doc,
                "imagem":           self.$root.user.imagem,
                "dataNascimento":   self.$root.user.dataNascimento.split("-")[2] + "/" + self.$root.user.dataNascimento.split("-")[1] + "/" + self.$root.user.dataNascimento.split("-")[0],
                "telefone":         self.$root.user.telefone
            }            
        }
    },
    methods: {
        apagarConta: function() {
            var self            = this;
            console.log("apagarConta");
            confirm("Atenção! Você tem certeza que deseja excluir a sua conta no aplicativo? Essa ação não poderá ser desfeita.", function(c) {

                loading.show();

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "acao":         "apagar"
                };                

                axios.put("api/conta.php", form)
                .then(response => {
                    console.log("ok", response.data.result)
                    loading.hide();
                    alert(response.data.message);
                    self.$root.logout();
                })
                .catch(error => {
                    loading.hide();
                    
                    alert(error.response.data.message || "Erro! Por favor, tente novamente.");
                });
            });

        },              
        getBase64Imagem: function(event) {
            console.log(">", event.target.files)
            var self            = this;

            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.9, blob => {
                    blobToBase64(blob, function(result) {
                        // console.log("result", result);
                        loading.hide();
                        self.form.imagem    = result;
                    });
                }); 
            }   
        },           
        submit: function(e) {
            var self            = this;
            console.log("submit", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
            
            axios.put("api/conta.php", self.form)
            .then(response => {
                self.loading.submit = false;
                console.log("ok", response.data.result)
                loading.hide();
                self.$root.setUser(response.data.result);
                alert(response.data.message);
                if (response.data.result) {
                    
                }
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert(error.response.data.message || "Erro! Por favor, tente novamente.");
            });

        }
    },    
    mounted: function() {
        loading.hide();
        $(".upload-button").on('click', function() {
            $(".file-upload").click();
        });             
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Conta.vue